<template>
<div style="display:inline-block" class="float-left w-100">
  <div ref="fadeWhenModelOpen">
    <div class="d-inline-flex w-100 float-left mt-4 ml-4 mb-4">
            <label style="width:13%;text-align:end;line-height: 22px;    position: relative;
    inset-inline-start:7px;" class="text-color">{{$t('Retrieval Path')}}</label>
            <div style="display:inline-block;text-align: initial;">
                    <input type="text" v-model="retrieveSettings.path" v-if="retrieveSettings.path != undefined && retrieveSettings.path.length" :style="{width:((retrieveSettings.path.length+1)*8) + 'px'}" class="rounded text-light non-editable-field text-light ml-3 pl-2" placeholder="select retrieve path from browse"/>
                    <span v-else class="empty-field-text-styles ml-4 mr-2">NONE</span>
                    <browse-icon v-on:click.native="openAddBinsBrowser()" style="height:26px;margin-inline-start:3px;position: relative;bottom: 5px;"></browse-icon>
                    <div class="config-desc ml-4">
                      {{$t('Selecting this value, group can have own retrieve path')}}.
                    </div>
          </div>
    </div>
        <div class="d-inline-flex w-100 ml-4 mt-2">
        <label style="width:22%;text-align:end;position: relative;
    inset-inline-end: 6px;" class="text-color mt-1">{{$t('Retrieve With')}}</label>
        <ul class="d-inline-block float-left pl-0" style="list-style-type:none">
            <li class="d-inline-block float-left w-100 ml-2 mb-3">
              <div class="custom-control w-100 custom-switch d-inline-flex">
                        <input
                            v-model="retrieveSettings.category_structure"
                            v-on:click="updateRetrieveSettings()"
                            type="checkbox"
                            class="custom-control-input"
                            id="customSwitch1"
                            :checked='retrieveSettings.category_structure'/>
                        <label class="custom-control-label" for="customSwitch1">{{$t('Catalog Folder Structure')}}</label>
                    </div>
                    <div class="config-desc">
                      {{$t('On file retrieve , file catalog structure created at retrieve path')}}.
                    </div>
            </li>
            <li class="d-inline-block float-left w-100 ml-2">
              <div class="custom-control w-100 custom-switch d-inline-flex">
                <input
                        v-model="retrieveSettings.date_structure"
                        v-on:click="updateRetrieveSettings()"
                        type="checkbox"
                        class="custom-control-input"
                        id="customSwitch2"
                        :checked='retrieveSettings.date_structure'/>
                  <label class="custom-control-label" for="customSwitch2">{{$t('Date Folder Structure')}}</label>
                  </div>
                <div class="config-desc">
                  {{$t('On file retrieve, todays date folder structure created at retrieve path')}}.
                      <div><b>{{$t('Example')}}:</b>  If default retrieve path set as “Retrieve“, and today's date is 01 Jan 2000, then file’s retrieve path will be <b>Share://Retrieve/Jan-2000/01-01-2020</b>.</div>
                </div>
            </li>
        </ul>
    </div>
    </div>
    <bins-browse-modal
      v-if="isModalVisible"
      :workspaceList="browseWorkspaceList"
      :enableAssetMultiSelect="false"
      @close="closeModal"
      @handleFilesBrowse="selectedBinPath"
      :enableRecursive="false"
      :browseOnlyFolders="true"
      style="z-index:99"
      :parentPreSelectedPathIds="[retrieveSettings.path]"
    ></bins-browse-modal>
</div>
</template>


<script>
import fileBrowseModel from "../files/filesBrowse.vue";
import Constants from "../../components.constants.js"
import browseIcon from "../core/InlineBrowseField.vue";
import {mapActions} from "vuex";
import Utils from "../../components.utils.js";

export default {
    props: ["selectedUserGroupID","newUserGroup","selectedUserGroupInfo"],
    data(){
        return{
            isModalVisible:false,
            retrieveSettings:{},
            browseWorkspaceList:[Constants.WORKSPACE_BINS],
        }
    },
    components:{
      "browse-icon" : browseIcon,
      "bins-browse-modal": fileBrowseModel,
    },
    methods:{
        getRetrievalConfigurations(){
            return this.retrieveSettings
        },
        openAddBinsBrowser(){
          this.isModalVisible = true;
          this.$refs.fadeWhenModelOpen.style.opacity = 0.2;
        },
         closeModal() {
              this.isModalVisible = false;
              this.$refs.fadeWhenModelOpen.style.opacity = 1;
        },
        selectedBinPath(folderInfoList){
          if(folderInfoList && folderInfoList.length > 0){
            this.retrieveSettings.path = folderInfoList[0].path
            this.updateRetrieveSettings()
            this.closeModal();
          }else{
            console.log("Failed to update the browsed folder path:",folderInfoList)
          }
        },
        updateRetrieveSettings(){
          setTimeout(() => {
            if(!this.newUserGroup){
                let payload={};
                payload.access_control = {"retrieval":this.retrieveSettings}
                payload.params = { _id: this.selectedUserGroupID };
                this.updateExistingUserGroup(payload).then((data) => {
                    if (Utils.isAcceptedStatusCode(data.statusCode)) {
                        if (data.message.includes("Failed")) {
                            this.$toast.warning(data.message);
                        } else {
                            this.$toast.success(data.message);
                        }
                    } else {
                        this.$toast.error(data.message);
                    }
                });
            }
          }, 1000);
        },
        ...mapActions("userGroups",["getUserGroupInfoFromServer","updateExistingUserGroup"]),
    },
    created(){
        if(this.newUserGroup){
            return
          }
          if(typeof(this.selectedUserGroupID) != "undefined"){
              if(this.selectedUserGroupInfo){
                this.retrieveSettings = this.selectedUserGroupInfo.access_control.retrieval;
              }
          }
    }
}
</script>

<style scoped lang="scss">
$border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $danger-color: #dc3545 !important;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $learn-about-text-color-hover:#b7b327;
    $active-green-icon-color: #00ff3a;
    $learn-about-text-color:#9a9620;

.config-desc{
  color: $dull-text-color;
}

.text-color{
  color:$dull-text-color;
}

.bigger-checkboxes{
    height: 30px;
    width: 20px;
}

input[type="radio"] {
    outline: none !important;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    display: inline-block;
    padding: 4px;
    border-radius: 50% !important;
    width: 20px;
    height: 20px;
}

input[type='checkbox']:after{
    line-height: 1.5em;
    content: '';
    display: inline-block;
    width: 22px;
    height: 21px;
    margin-top: 5px;
    margin-inline-start: -1px;
    border: $border-color;
    border-radius: 0.25em;
    background: $primary-background;
}

input[type='checkbox']:checked:after{
    content: '✔';
    color: $active-blue !important;
    // position: absolute;
    font-size: 16px;
    line-height: 1;
    transition: all .2s;
    font-family: Helvetica, Arial, sans-serif;
    padding-inline-start: 4px;
    padding-top:2px;
}


/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}

.users-basic-info-table {
  tbody {
    margin: 10px;
    .key-div {
      text-align: end;
      color: $dull-text-color;
    }
    .value-div {
      text-align: start;
      margin-inline-start: 10px;
    }
  }
}


.border {
    border: $border-color!important;
}

.heightSet{
  overflow: auto;
  position: absolute;
  width: 100%;
  // height:calc(100%-130px)
}
.hideShowIcons{
    position: absolute;
    inset-inline-start:0px;
    top: -2%;
    width: 22px;
    height: 21px;
}
.bigger-checkboxes {
  height: 30px;
  width: 20px;
  position:relative;
}

.field-description {
  font-size: 11px;
  color: $dull-text-color;
}

table {
  background: transparent;
  thead {
    th {
      color: $dull-text-color;
      border-top: none !important;
      border-bottom: none !important;
    }
  }
  tbody {
    color: $text-color;
    td {
      border-top: none !important;
    }
  }
}

.comm-input-field-style{
    background: $primary-background!important;
    width: 50% !important;
    float: inline-start;
    padding: $input-field-padding;
    border: $border-color!important;
    font-size:$input-field-and-label-font-size;
    height: $input-field-height;
}

.non-editable-field{
    border: none !important;
    pointer-events: none;
    cursor: default;
    position: relative;
    bottom: 4px;
}

.config-desc{
  width: 90%;
  text-align: initial;
}

.empty-field-text-styles{
  color:$none-text-color;
}

</style>